define(
    'modules/product-filter',[
        'jquery',
        'settings',

        'utils/url-hash-manager',
        'utils/get-object-where'
    ],

    function ($, settings, UrlHashManager, getObjectWhere) {
        return (function () {
            /**
             * @class ProductFilter
             * @constructor
             */
            function ProductFilter (container) {
                this.hashManager = new UrlHashManager();
                this.selectedFilters={};
                this.container = container;
                
                this.addFilterToggleBindings();
                this.initCheckboxBindings();
                this.initCheckboxes();
                this.initClearButtons();

                if ($('.product-filter-panel').length) this.initFilterHeader();
            }

            /**
             * Add toggle bindings to filter for smaller devices
             */
            ProductFilter.prototype.addFilterToggleBindings = function() {
                var _this = this;

                this.container.find('.filter-header').on('click', function() {
                    $(_this.container).toggleClass('minimized');
                });

                this.container.find('.filter-close').on('click', function() {
                    $(_this.container).addClass('minimized');
                });
            };

            /**
             * Add filter to the list of selected filters
             *
             * @param {String} key   Filter name
             * @param {String} value Filter value
             * @param {Boolean} noEvent = false - Disable changeEvent for this update.
             * @method addFilterToSelectedList
             */
            ProductFilter.prototype.addFilterToSelectedList = function(key, value, noEvent) {
                this.selectedFilters[key] = this.selectedFilters[key] ? this.selectedFilters[key] : [];
                this.selectedFilters[key].push(value);

                if (!noEvent) this.triggerFilterChanged();
            };

            /**
             * Remove filter from the list of selected filters
             *
             * @param {String} key   Filter name
             * @param {String} value Filter value is optional
             * @param {Boolean} noEvent = false - Disable changeEvent for this update.
             * @method removeFilterFromSelectedList
             */
            ProductFilter.prototype.removeFilterFromSelectedList = function(key, value, noEvent) {
                this.selectedFilters[key] = this.selectedFilters[key] ? this.selectedFilters[key] : [];

                if (typeof value !== 'undefined') {
                    var i = this.selectedFilters[key].indexOf(value);
                    if (i >= 0) {
                        this.selectedFilters[key].splice(i, 1);
                    }

                    if (this.selectedFilters[key].length === 0) {
                        delete this.selectedFilters[key];
                    }

                } else {
                    delete this.selectedFilters[key];
                }

                if (!noEvent) this.triggerFilterChanged();
            };

            /**
             * Initiates filter header. Adds listener to toggle the filter and to checkbox changes, displaying filter-boxes
             * in the header.
             *
             * @method initFilterHeader
             */
            ProductFilter.prototype.initFilterHeader = function() {
                var _this = this;

                this.container.on('filterChanged', function() {
                    _this.updateActiveFiltersCounter();
                    _this.displayActiveFilters();
                });

                // TODO
                $('.filter__box').on('click', function() {
                    _this.toggleFilter(this);
                });

                _this.updateActiveFiltersCounter();
                _this.displayActiveFilters();

                _this.toggleFixedFilterbar();
            };

            /**
             * Toggles visibility of fixed filter- and navigation bar on scroll
             *
             * @method  toggleFixedFilterbar
             */
            ProductFilter.prototype.toggleFixedFilterbar = function() {
                var filterbar = $('.product-filter-panel');
                if (filterbar.length < 1) return;

                var _this = this,
                navbar = $('.navigation-bar'),
                stickyClass = 'product-filter-panel--fixed',
                offsetY = filterbar.position().top,
                scrollTop,
                lastScrollTop = 0;

                $(document).on('scroll', function (event) {
                    scrollTop = $(window).scrollTop();
                    var st = $(this).scrollTop();

                    // Toggle fixed filter panel
                    if (scrollTop > offsetY) {
                        filterbar.addClass(stickyClass);
                    }
                    else {
                        filterbar.removeClass(stickyClass);
                    }

                    // Toggle both fixed navigation bar and filter panel when scrolling up and down
                    if (st < lastScrollTop && st > offsetY){
                        // upscroll code
                        filterbar.css({top: navbar.outerHeight()});
                        navbar.css({top : 0});
                    }
                    else if (st > lastScrollTop && st > offsetY) {
                        // downscroll code
                        filterbar.css({top : 0});
                        navbar.css({top : -navbar.outerHeight()});
                    }
                    lastScrollTop = st;
                });
            };

            /**
             * Toggles visibility of the filters.
             *
             * @method toggleFilter
             */
            ProductFilter.prototype.toggleFilter = function(e) {
                var filter = $(e).data('filter');
                $(e).toggleClass('show');
                $('[name="' + filter + '"]').toggleClass('show');
            };

            /**
             * Updates the filter header, displaying a box for each active filter.
             *
             * @method displayActiveFilters
             */
            ProductFilter.prototype.displayActiveFilters = function() {
                var _this = this;
                var activeFiltersContainer = $("#active-filters");
                var selectedFilters = this.getSeletectedFilters();

                activeFiltersContainer.empty();

                // Creates a filter header box for each active filter and connects it to corresponding checkbox.
                $.each(selectedFilters, function(filter, array) {
                    $.each(array, function(key, value) {
                        var checkbox = _this.getCheckbox(filter, value);
                        var label = _this.getCheckboxLabel(checkbox);
                        var span = $("<span></span>")
                            .addClass('active-filters__box')
                            .text(label)
                            .attr('name', checkbox.attr('name'))
                            .append('<span class="icon-cancel"></span>')
                            .val(checkbox.val())
                            .on('click', function() {
                                var key = $(this).attr('name').replace('[]', '');
                                var val = $(this).val();
                                var checkbox = _this.getCheckbox(key, val);

                                _this.uncheckCheckbox(checkbox);
                                _this.removeFilterFromSelectedList(key, val);
                                _this.hashManager.subtract(key, [value]);
                            });

                        activeFiltersContainer.append(span);
                    });
                });
            };

            /**
             * Trigger bounce effect on active filter counter
             *
             * @method  bounceActiveFiltersCounter
             */
            ProductFilter.prototype.bounceActiveFiltersCounter = function() {
                $("#filter-count").addClass( "bounce" ).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function(){
                    $(this).removeClass( "bounce" );
                });
            };

            /**
             * Updates counter to number of active filters and removes it if there are no active filters.
             *
             * @method updateActiveFilterCounter
             */
            ProductFilter.prototype.updateActiveFiltersCounter = function() {
                var len = this.getNumberOfSelectedFilters();
                var selectedFilters = $("#filter-count");

                if (len) {
                    selectedFilters.toggle(true).text(len);

                    this.bounceActiveFiltersCounter();
                } else {
                    selectedFilters.toggle(false);
                }
            };

            /**
             * Event is fired when any of filters is changed or set
             * @method triggerFilterChanged
             */
            ProductFilter.prototype.triggerFilterChanged = function() {
                this.container.trigger('filterChanged');
            };

            /**
             * Update quantity of items for each filter.
             *
             * @method updateQuantity
             */
            ProductFilter.prototype.updateQuantity = function(data) {
            /*
                 var dataKey,
                 itemKey,
                 checkbox = {};

                 this.clean();

                 for (dataKey in data) {
                     if (data.hasOwnProperty(dataKey)) {
                         checkbox.name = data[dataKey].name;

                         if (checkbox.name in this.selectedFilters) {
                            continue;
                         }

                         for (itemKey in data[dataKey].items) {
                            checkbox.value = data[dataKey].items[itemKey].value;
                            checkbox.quantity = data[dataKey].items[itemKey].quantity;
                            checkbox.dom = this.getCheckbox(checkbox.name, checkbox.value);
                            checkbox.dom.parent().find('.checkbox__label').find('span').text(' ('+ checkbox.quantity +')');
                            if (checkbox.quantity === 0) {
                                 if (this.isCheckedCheckbox(checkbox.dom)) {
                                    this.uncheckCheckbox(checkbox.dom);
                                    this.removeFilterFromSelectedList(checkbox.name, checkbox.value, true);
                                    this.hashManager.subtract(checkbox.name, [checkbox.value]);
                                }
                                this.disableCheckbox(checkbox.dom);
                            }
                        }

                    }
                }
            */
            };

            /**
             * Remove all quantities from all lables
             * Enable all checkboxes from all lables
             *
             * @method clean
             */
            ProductFilter.prototype.clean = function(data) {
                this.container.find('.checkbox__label').find('span').text('');
                this.enableCheckbox(this.container.find('input[type=checkbox]').filter(':disabled'));
            };

            /**
             * Get selected filters
             *
             * @method getSeletectedFilters
             * @param {Sting} filterName name of filter (categories, sizes... without brackets)
             *
             * @return {Object} if filterName is not set
             * @return {Array} if filterName is set and selected
             * @return {Boolean} if filterName is set, but not selected
             */
            ProductFilter.prototype.getSeletectedFilters = function(filterName) {
                if ( filterName ) {
                    if (this.selectedFilters.hasOwnProperty(filterName)) {
                        return this.selectedFilters[filterName];
                    } else {
                        return false;
                    }
                }
                return this.selectedFilters;
            };

            /**
             * Get amount of selected filters.
             *
             * @return {Number}
             */
            ProductFilter.prototype.getNumberOfSelectedFilters = function() {
                var selectedFilters = this.getSeletectedFilters();
                var count = 0;

                $.each(selectedFilters, function(filterType, filters) {
                    count += filters.length;
                });

                return count;
            };

            /**
             * Initializes all the checkbox bindings on change (to update url hash and what not)
             *
             * @method initCheckboxBindings
             */
            ProductFilter.prototype.initCheckboxBindings = function () {
                var _this = this;

                this.container.find('[type=checkbox]').on('change', function () {
                    var key = $(this).attr('name').replace('[]', ''),
                        value = $(this).val();

                    if ($(this).is(':checked')) {
                        _this.addFilterToSelectedList(key, value);
                        _this.hashManager.append(key, [value]);
                    } else {
                        _this.removeFilterFromSelectedList(key, value);
                        _this.hashManager.subtract(key, [value]);
                    }
                });
            };

            /**
             * Makes sure that the checkboxes are in sync with the url hash
             * on initialization
             *
             * @method initCheckboxes
             */
            ProductFilter.prototype.initCheckboxes = function () {
                var data = this.hashManager.getAll(),
                    name,
                    valuesList,
                    valueItem,
                    checkbox;
                    
                    //Firefox fix for cache bug, uncheck all checkboxes.
                    $(':checkbox:checked').prop('checked',false);

                for (name in data) {
                    if (data.hasOwnProperty(name)) {
                        valuesList = data[name];

                        for (var i = 0; i < valuesList.length; i++) {
                            valueItem = valuesList[i];

                            checkbox = this.getCheckbox(name, valueItem);
                            if (checkbox.length) {
                                this.checkCheckbox(checkbox);
                                this.addFilterToSelectedList(name, valueItem, true);
                            }
                        }
                    }
                }
            };

            /**
             * Setups up the clear buttons on each "category" of filters
             *
             * @method initClearButtons
             */
            ProductFilter.prototype.initClearButtons = function () {
                var _this = this;

                $('.product-filter--listing__clear').on('click', function (event) {
                    event.preventDefault();

                    var box = $(this).closest('.box'),
                        checkboxes = box.find('input').filter('[type="checkbox"]');
                    
                    if (!checkboxes.length) return; 
                    
                    var key = checkboxes.attr('name').replace('[]', '');

                    _this.removeFilterFromSelectedList(key);
                    _this.hashManager.remove(key);
                    checkboxes.prop('checked', false);
                });

                $('.product-filter--listing__clear__all').on('click', function (event) {
                    event.preventDefault();
                    $('.product-filter--listing__clear').click();
                    _this.container.find('.search-field').trigger('clear');
                });
            };

            /**
             * Get jQuery obj by key and value
             *
             * @method getCheckbox
             * @param  {String} key   checkbox name (without array brackets)
             * @param  {String} value checkbox value
             * @return {jQuery}
             */
            ProductFilter.prototype.getCheckbox = function(key, value) {
                return this.container.find('input').filter('[name="'+ key +'[]"]').filter('[value="'+ value +'"]');
            };

            /**
             * Get checkbox label
             *
             * @method getCheckboxLabel
             * @param  {jQuery}  checkbox
             * @return {String}
             */
            ProductFilter.prototype.getCheckboxLabel = function(checkbox) {
                var t = checkbox.parent().find('.checkbox__label').clone();
                t.find('span').remove();
                return $.trim(t.text());
            };

            /**
             * Get whether checkbox is checked
             *
             * @method isCheckedCheckbox
             * @param  {jQuery}  checkbox
             * @return {Boolean}
             */
            ProductFilter.prototype.isCheckedCheckbox = function(checkbox) {
                return checkbox.prop("checked");
            };

            /**
             * Set checkbox checked
             *
             * @method checkCheckbox
             * @param  {jQuery}  checkbox
             */
            ProductFilter.prototype.checkCheckbox = function(checkbox) {
                checkbox.prop("checked", true);
            };

            /**
             * Set checkbox unchecked
             *
             * @method uncheckCheckbox
             * @param  {jQuery} checkbox
             */
            ProductFilter.prototype.uncheckCheckbox = function(checkbox) {
                checkbox.prop("checked", false);
            };

            /**
             * Set checkbox disabled
             *
             * @method disableCheckbox
             * @param  {jQuery} checkbox
             */
            ProductFilter.prototype.disableCheckbox = function(checkbox) {
                checkbox.prop("disabled", true);
            };

            /**
             * Set checkbox enabled / removes disabled property
             *
             * @method enableCheckbox
             * @param  {jQuery} checkbox
             */
            ProductFilter.prototype.enableCheckbox = function(checkbox) {
                checkbox.prop("disabled", false);
            };

            return ProductFilter;
        })();
    }
);

